export default "__VITE_ASSET__1d969916__"